document.addEventListener('DOMContentLoaded', function() {

    let scrollbarWidth = getScrollbarWidth();
    document.documentElement.style.setProperty('--scrollbar', scrollbarWidth+'px');

});

function getScrollbarWidth() {

    const hasVerticalScrollbar = document.documentElement.scrollHeight > document.documentElement.clientHeight;

    if (!hasVerticalScrollbar) {
        return 0;
    }

    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.width = '100px';
    outer.style.position = 'absolute';
    outer.style.top = '-9999px';
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    document.body.removeChild(outer);

    return scrollbarWidth;
  
}